import { render, staticRenderFns } from "./marketData.vue?vue&type=template&id=1268aac6&scoped=true&"
import script from "./marketData.vue?vue&type=script&lang=js&"
export * from "./marketData.vue?vue&type=script&lang=js&"
import style0 from "./marketData.vue?vue&type=style&index=0&id=1268aac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1268aac6",
  null
  
)

export default component.exports